import React from 'react';
import { faSwimmingPool } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const AddPoolIcon = () => (
  <Icon tooltip="Add Pool" iconObj={faSwimmingPool} />
);

export default AddPoolIcon;